
export default {
  tabs: [
    { label: '我发起的审批', value: 'self' },
  ],
}
